import { render, staticRenderFns } from "./Special_list.vue?vue&type=template&id=3694a466&scoped=true&"
import script from "./Special_list.vue?vue&type=script&lang=js&"
export * from "./Special_list.vue?vue&type=script&lang=js&"
import style0 from "./Special_list.vue?vue&type=style&index=0&id=3694a466&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3694a466",
  null
  
)

export default component.exports